<script>
export default {
  components: {},
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
  computed: {
    getCompanyInfo: function () {
      let cInfo = this.$store.state.appAuth.companyInfo || null
      if (cInfo && cInfo.primary_color){
        document.body.style.backgroundColor = cInfo.primary_color;
      }
      return cInfo
    },
    langSelected: {
      get() {
        return this.$store.state.language.language
      },
      set(val) {
        this.$store.commit('language/SET_LANGUAGE', val)
      }
    },
    langFlagSelected: function () {
      return this.$store.state.language.languages.find(x => this.langSelected === x.value).flag
    }
  },
  created: () => {
    document.body.classList.add('authentication-bg');
    document.body.classList.add('authentication-bg-pattern');
  }
}
</script>

<template>
<div>
  <!-- Traduction options -->
  <!--<div class="flag-language float-right">
    <b-nav-item-dropdown
          right
          class="p-0 flag"
          menu-class="language-dropdown"
        >
      <template slot="button-content">
        <div class="show dropdown-toggle">
          <b-img
            :src="require('@assets/images/flags/'+(langFlagSelected || 'ss')+'.svg')"
            alt="lang-image"
            width="20"
            class="my-1"
          />
          <span class="pro-user-name ml-1">
            <i class="mdi mdi-chevron-down"></i>
          </span>
        </div>
      </template>
      <b-dropdown-item v-for="(lang, i) in $store.state.language.languages" :key="`Lang${i}`" 
        @click="langSelected = lang.value" class="p-0">
        <img
          :src="require('@assets/images/flags/'+lang.flag+'.svg')"
          width="20"
          class="mr-2 my-0"
        />
        <span>{{ lang.name }}</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>-->
  <!-- content -->
  <div class="account-pages pt-5 mb-4">
    <div class="container">
      <slot />
    </div>
  </div>
  <footer class="footer footer-alt">
    &copy; {{ $t('copyright') }}, {{ currentYear }}, 
    {{ getCompanyInfo && getCompanyInfo.company_name ? getCompanyInfo.company_name : ''}} 
    {{ getCompanyInfo && getCompanyInfo.git_version ? ' | ' + getCompanyInfo.git_version : ''}}
  </footer>
</div>
</template>

<style lang="scss" scoped>
.flag-language {
  position: absolute;
  top: 2px;
  right: 2px;
  .flag {
    padding: 0.5rem;
    display: inline-flex;
    list-style: none !important;
  }
}
</style>